module.exports = __webpack_public_path__ + "static/media/do1.e5804f74.png";